import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=b3c43fb8"
import script from "./input-number.vue?vue&type=script&lang=js"
export * from "./input-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5bba9927a18eaff02a55b79fc72fdde2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports